<template>
  <el-container direction="vertical" id="correctingHistoryDetails">
    <el-main>
      <el-col :span="16" :push="4">
        <el-form label-width="150px" style="text-align: left;">
          <el-card class="box-card">
            <div class="box-card-div-title userInfo">
              <div class="header">批单详情</div>
            </div>
            <el-form-item class="form-item-label" label="保单号">
              <div class="rightUnit">{{accode}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="投保企业名称">
              <div class="rightUnit">{{dynamicValidateForm.companyName}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="有效期间">
              <div class="rightUnit">{{orderInfoLog.effectiveDate}} —— {{orderInfoLog.expireDate}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="批改生效日期">
              <div class="rightUnit">{{correctingDate}}</div>
            </el-form-item>
            <el-form-item v-if="$$.isValidObj(orderEndorInfoLogEntity.name)" class="form-item-label" label="联系人">
              <div class="rightUnit">{{orderEndorInfoLogEntity.name}}</div>
            </el-form-item>
            <el-form-item v-if="$$.isValidObj(orderEndorInfoLogEntity.mobile)" class="form-item-label" label="联系手机">
              <div class="rightUnit">{{orderEndorInfoLogEntity.mobile}}</div>
            </el-form-item>
            <el-form-item v-if="$$.isValidObj(orderEndorInfoLogEntity.applyDesc)" class="form-item-label" label="申请说明">
              <div class="rightUnit">{{orderEndorInfoLogEntity.applyDesc}}</div>
            </el-form-item>
            <el-form-item class="form-item-label addPersonnel "
                          :label="orderEndorInfoLogEntity.type === 4 ? '被保人信息修改后' : orderEndorInfoLogEntity.type === 3 ? '投保人信息修改后' : '增加人员' ">
              <el-table
                ref="addPersonnelList"
                :data="$$.isEmptyObject(endorInsuredAddList) ? endorPolicyAddList : endorInsuredAddList"
                border
                style="width: 100%;margin-bottom: 15px">
                <span v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                  <el-table-column :width="width"></el-table-column>
                   <el-table-column
                     prop="name"
                     label="被保险人姓名"
                     width="110">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="60">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}">
                      {{$$.isValidObj(scope.row.skuId) ? '保障计划'+supportPlan(scope.row.skuId, 0) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="职业类别">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}">
                      <span v-if="isEjsino">{{$$.isValidObj(scope.row.occupationName) && scope.row.occupationName.toString().indexOf('类') >= 0 ? scope.row.occupationName.substring(scope.row.occupationName.toString().indexOf('类')-1,scope.row.occupationName.toString().indexOf('类')+1) : '未设置'}}</span>
                      <span v-else>{{$$.isValidObj(scope.row.skuId) ? supportPlan(scope.row.skuId, 1) : '未设置'}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="idnumber"
                  width="170"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  width="100"
                  label="增加保费" v-if="!isEjsino">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    <div :style="{color: scope.row.insuMoney == 0 ? '#FF7052' : ''}">
                      {{scope.row.insuMoney == 0 ? '——' : scope.row.insuMoney + '元'}}
                    </div>
                  </template>
                </el-table-column>
                </span>
                <span v-else-if="orderEndorInfoLogEntity.type === 3">
                  <el-table-column :width="width"></el-table-column>
                  <el-table-column
                    prop="companyName"
                    label="投保单位">
                </el-table-column>
                  <el-table-column
                    prop="idtype"
                    label="证件类型">
                    <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type === 3">
                    {{scope.row.idtype === 6 ? '社会统一信用代码' : ''}}
                  </template>
                </el-table-column>
                  <el-table-column
                    prop="idnumber"
                    label="证件号码">
                </el-table-column>
                  <el-table-column
                    prop="address"
                    label="所在地区">
                </el-table-column>
                  <el-table-column
                    prop="companyaddress"
                    label="单位地址">
                </el-table-column>
                  <el-table-column
                    prop="name"
                    label="联系人姓名">
                </el-table-column>
                  <el-table-column
                    prop="mobile"
                    label="联系人手机">
                </el-table-column>
                  <el-table-column
                    prop="email"
                    label="联系人邮箱">
                </el-table-column>
                </span>
                <span v-else-if="orderEndorInfoLogEntity.type === 4">
                  <el-table-column :width="width"></el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>
                  <el-table-column
                    prop="idtype"
                    label="证件类型">
                    <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type === 4">
                    {{scope.row.idtype === 1 ? '身份证' : '护照'}}
                  </template>
                </el-table-column>
                  <el-table-column
                    prop="idnumber"
                    label="证件号码">
                </el-table-column>

                  <el-table-column
                    prop="brithday"
                    label="出生日期">
                </el-table-column>
                  <el-table-column
                    prop="sex"
                    label="性别">
                    <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type === 4">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                </span>
              </el-table>
            </el-form-item>
            <el-form-item class="form-item-label addPersonnel "
                          :label="orderEndorInfoLogEntity.type === 4 ? '被保人信息修改前' : orderEndorInfoLogEntity.type === 3 ? '投保人信息修改前' :'退保人员'">
              <el-table
                :data="$$.isEmptyObject(endorInsuredSubtractList) ? endorPolicySubtractList : endorInsuredSubtractList"
                border
                style="width: 100%;margin-bottom: 15px">
                <span v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                  <el-table-column :width="width"></el-table-column>
                   <el-table-column
                     prop="name"
                     label="被保险人姓名"
                     width="110">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="60">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}">
                      {{$$.isValidObj(scope.row.skuId) ? '保障计划'+supportPlan(scope.row.skuId, 0) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="职业类别">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}">
                      <span v-if="isEjsino">{{$$.isValidObj(scope.row.occupationName) && scope.row.occupationName.toString().indexOf('类') >= 0 ? scope.row.occupationName.substring(scope.row.occupationName.toString().indexOf('类')-1,scope.row.occupationName.toString().indexOf('类')+1) : '未设置'}}</span>
                      <span v-else>{{$$.isValidObj(scope.row.skuId) ? supportPlan(scope.row.skuId, 1) : '未设置'}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="idnumber"
                  width="170"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  width="100"
                  label="增加保费" v-if="!isEjsino">
                  <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
                    <div :style="{color: scope.row.insuMoney == 0 ? '#FF7052' : ''}">
                      {{scope.row.insuMoney == 0 ? '——' : scope.row.insuMoney + '元'}}
                    </div>
                  </template>
                </el-table-column>
                </span>
                <span v-else-if="orderEndorInfoLogEntity.type === 3">
                  <el-table-column :width="width"></el-table-column>
                  <el-table-column
                    prop="companyName"
                    label="投保单位">
                </el-table-column>
                  <el-table-column
                    prop="idtype"
                    label="证件类型">
                    <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type === 3">
                    {{scope.row.idtype === 6 ? '社会统一信用代码' : ''}}
                  </template>
                </el-table-column>
                  <el-table-column
                    prop="idnumber"
                    label="证件号码">
                </el-table-column>
                  <el-table-column
                    prop="address"
                    label="所在地区">
                </el-table-column>
                  <el-table-column
                    prop="companyaddress"
                    label="单位地址">
                </el-table-column>
                  <el-table-column
                    prop="name"
                    label="联系人姓名">
                </el-table-column>
                  <el-table-column
                    prop="mobile"
                    label="联系人手机">
                </el-table-column>
                   <el-table-column
                     prop="email"
                     label="联系人邮箱">
                </el-table-column>
                </span>
                <span v-else-if="orderEndorInfoLogEntity.type === 4">
                  <el-table-column :width="width"></el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>
                  <el-table-column
                    prop="idtype"
                    label="证件类型">
                    <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type === 4">
                    {{scope.row.idtype === 1 ? '身份证' : '护照'}}
                  </template>
                </el-table-column>
                  <el-table-column
                    prop="idnumber"
                    label="证件号码">
                </el-table-column>

                  <el-table-column
                    prop="brithday"
                    label="出生日期">
                </el-table-column>
                   <el-table-column
                     prop="sex"
                     label="性别">
                    <template slot-scope="scope" v-if="orderEndorInfoLogEntity.type === 4">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                </span>
              </el-table>
            </el-form-item>
            <span v-if="orderEndorInfoLogEntity.type !== 4 && orderEndorInfoLogEntity.type !== 3">
              <el-form-item class="form-item-label" label="加保人员数量合计">
              <div class="rightUnit">{{addHeadcount}}人</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="加保人员保费合计" v-if="!isEjsino">
                <div class="rightUnit">{{addTotalPremium}}元</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="退保人员数量合计">
                <div class="rightUnit">{{subtractHeadcount}}人</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="退保人员保费合计" v-if="!isEjsino">
                <div
                  class="rightUnit">{{subtractTotalPremium == 0 ? subtractTotalPremium : '-'+subtractTotalPremium}}元</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="合计保费变更">
                <div class="rightUnit">{{totalPremium}}元</div>
              </el-form-item>
              <el-form-item class="form-item-label" :label="actualPremiumsName">
                <div class="rightUnit">{{actualPremiums}}元</div>
                  <p class="warmPrompt" v-if="refundWarmPrompt">温馨提示：由于产生保费退费，需要补扣佣金{{paidInPremium}}元，佣金从钱包扣除</p>
              </el-form-item>
              <el-form-item class="form-item-label" label="开户银行" v-if="isEjsino && totalPremium <= 0">
                <div class="rightUnit">{{bankData[0]+bankData[1]+bankData[2]}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="收款账号" v-if="isEjsino && totalPremium <= 0">
                <div class="rightUnit">{{bankData[3]}}</div>
              </el-form-item>
            </span>

          <!-- 保全文件 -->
            <el-form-item class="form-item-label" label="批改申请书" v-if="fileTypeOne">
              <el-upload
                v-for="file in orderEndorFileList"
                v-if="file.fileType === 1"
                style="display: inline-block"
                :key="file.id"
                action="#"
                :disabled="true"
                list-type="picture-card">
                <img v-if="'jpg,jpeg,png,gif'.indexOf(file.fileUrl.substring(file.fileUrl.lastIndexOf('.')+1, file.fileUrl.length)) >= 0 "
                     @click="uploadClick(file.fileUrl)" width="100%" height="100%" :src="file.fileUrl" alt="">
                <a v-else style="text-decoration:none;font-size: 50px" target="_blank" :href="file.fileUrl"><span>{{file.fileUrl.substring(file.fileUrl.lastIndexOf('.')+1, file.fileUrl.length)}}</span></a>
              </el-upload>
            </el-form-item>
            <el-form-item class="form-item-label" label="人员清单电子版" v-if="fileTypeTwo">
              <el-upload
                v-for="file in orderEndorFileList"
                v-if="file.fileType === 2"
                style="display: inline-block"
                :key="file.id"
                action="#"
                :disabled="true"
                list-type="picture-card">
                <img v-if="'jpg,jpeg,png,gif'.indexOf(file.fileUrl.substring(file.fileUrl.lastIndexOf('.')+1, file.fileUrl.length)) >= 0 "
                     @click="uploadClick(file.fileUrl)" width="100%" height="100%" :src="file.fileUrl" alt="">
                <a v-else style="text-decoration:none;font-size: 50px" target="_blank" :href="file.fileUrl"><span>{{file.fileUrl.substring(file.fileUrl.lastIndexOf('.')+1, file.fileUrl.length)}}</span></a>
              </el-upload>
            </el-form-item>
            <el-form-item class="form-item-label" label="人员清单盖章件" v-if="fileTypeThree">
              <el-upload
                v-for="file in orderEndorFileList"
                v-if="file.fileType === 3"
                style="display: inline-block"
                :key="file.id"
                action="#"
                :disabled="true"
                list-type="picture-card">
                <img v-if="'jpg,jpeg,png,gif'.indexOf(file.fileUrl.substring(file.fileUrl.lastIndexOf('.')+1, file.fileUrl.length)) >= 0 "
                     @click="uploadClick(file.fileUrl)" width="100%" height="100%" :src="file.fileUrl" alt="">
                <a v-else style="text-decoration:none;font-size: 50px" target="_blank" :href="file.fileUrl"><span>{{file.fileUrl.substring(file.fileUrl.lastIndexOf('.')+1, file.fileUrl.length)}}</span></a>
              </el-upload>
            </el-form-item>
            <el-dialog :visible.sync="imgShow">
              <img width="100%" :src="imgUrl" alt="">
            </el-dialog>
          </el-card>
          <el-card class="box-card" v-if="totalPremium>0 && needInvoices" >
            <div class="box-card-div-title invoiceInformation">
              <div class="header">发票信息</div>
            </div>
        <!--    <el-form-item label="是否需要" class="form-item-label-big">
              <el-radio-group v-model="needInvoices">
                <el-radio-button class="my-button" :disabled="true" :label="true">需要</el-radio-button>
                <el-radio-button class="my-button" :disabled="true" :label="false">不需要</el-radio-button>
              </el-radio-group>
            </el-form-item>-->
            <span v-if="needInvoices">
              <el-form-item label="发票类型" class="form-item-label-big">
              <div>
                <el-radio-group v-model="receiptType">
                  <el-radio-button class="my-button" :disabled="true" :label="2" v-if="receiptType === 2">普通发票(电子发票)</el-radio-button>
                  <el-radio-button class="my-button" :disabled="true" :label="1" v-if="!isEjsino && receiptType === 1">增值税专用发票（纸质发票）</el-radio-button>
                  <el-radio-button class="my-button" :disabled="true" :label="3" v-if="isEjsino && receiptType === 3">增值税专用发票（纸质发票）</el-radio-button>
                </el-radio-group>
              </div>
              </el-form-item>
              <span v-if="receiptType === 2">
                <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                <el-form-item label="发票抬头" class="form-item-label">
                  <el-input :disabled="true" class="form-item-input my-input-left "
                            v-model="dynamicValidateForm.companyName"
                            placeholder="请输入发票抬头"
                  ></el-input>
                </el-form-item>
                <el-form-item label="纳税人识别号" class="form-item-label">
                  <el-input v-if="idType === 6" class="form-item-input my-input-left "
                            v-model="socialCreditCode"
                            :disabled="true"
                            placeholder="请输入纳税人识别号"
                  ></el-input>
                  <el-input v-else class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.tIN"
                            placeholder="请输入纳税人识别号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                <el-form-item label="收件人姓名" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.rName"
                            placeholder="请输入收件人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人手机号" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.rPhone"
                            placeholder="请输入收件人手机号码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人邮箱" class="form-item-label"  v-if="$$.isValidObj(orderMailInvoiceInfo.rMail)">
                  <el-input class="form-item-input my-input-left "
                            :disabled="true"
                            v-model="orderMailInvoiceInfo.rMail"
                            placeholder="请输入收件人邮箱"
                  ></el-input>
                </el-form-item>
              </span>
              <span v-else-if="receiptType === 1">
                <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                  <el-form-item label="发票抬头" class="form-item-label">
                    <el-input :disabled="true" class="form-item-input my-input-left "
                              v-model="dynamicValidateForm.companyName"
                              placeholder="请输入发票抬头"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="纳税人识别号" class="form-item-label">
                    <el-input v-if="idType === 6" class="form-item-input my-input-left "
                              v-model="socialCreditCode"
                              :disabled="true"
                              placeholder="请输入纳税人识别号"
                    ></el-input>
                    <el-input v-else class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.tIN"
                              placeholder="请输入纳税人识别号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="税务登记地址" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.tRA"
                              placeholder="请输入税务登记地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="税务登记电话" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.tRT"
                              placeholder="请输入税务登记电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="开户银行" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.openBank"
                              placeholder="请输入开户银行"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="银行账户" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.bankNum"
                              placeholder="银行账户"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                  <el-form-item label="收件人姓名" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.rName"
                              placeholder="请输入收件人姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人手机号" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.rPhone"
                              placeholder="请输入收件人手机号码"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人地址" class="form-item-label">
                  <el-select v-model="orderMailInvoiceInfo.rProvinceId" placeholder="请选择"
                             :disabled="true"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in chinaArea"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="orderMailInvoiceInfo.rCityId" placeholder="请选择"
                             :disabled="true"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in orderMailInvoiceInfo.rCityList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="orderMailInvoiceInfo.rAreaId" placeholder="请选择"
                             :disabled="true"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in orderMailInvoiceInfo.rAreaList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  </el-form-item>
                  <el-form-item label="具体地址" class="form-item-label">
                    <el-input class="form-item-input my-input-left " style="width: 640px;"
                              :disabled="true"
                              v-model="orderMailInvoiceInfo.rAddress"
                              placeholder="请输入具体地址"
                    ></el-input>
                  </el-form-item>
              </span>
            </span>
          </el-card>
          <div class="submitOrder">
            <el-button v-if="isEjsino && (orderEndorInfoLogEntity.endorStatus === 0 || orderEndorInfoLogEntity.endorStatus === 1)" @click="submitOrder" class="header-button-order-add">提交订单</el-button>
            <el-button v-if="isEjsino && orderEndorInfoLogEntity.endorStatus === 0" @click="onEdit" class="header-button-order-add">编辑订单</el-button>
            <el-button class="header-button-order-add" @click="requestInvoiceData(orderEndorInfoLogEntity.endorOrderIdNum, '01')" v-if="totalPremium > 0 && !needInvoices && isEjsino && orderEndorInfoLogEntity.endorStatus == 2 && (orderEndorInfoLogEntity.isInsuredStatus == 1 || orderEndorInfoLogEntity.isInsuredStatus == 7)" >发票申请</el-button>
            <el-button class="header-button-order-add" @click="requestInvoiceData(orderEndorInfoLogEntity.endorOrderIdNum, '04')" v-if="totalPremium > 0 && needInvoices && isEjsino && orderEndorInfoLogEntity.endorStatus == 2 && (orderEndorInfoLogEntity.isInsuredStatus == 1 || orderEndorInfoLogEntity.isInsuredStatus == 7)" >发票预览</el-button>
            <el-button class="header-button-order-add" @click="requestInvoiceData(orderEndorInfoLogEntity.endorOrderIdNum, '03')" v-if="totalPremium > 0 && needInvoices && orderMailInvoiceInfo.invoiceStatus == 6 && isEjsino && orderEndorInfoLogEntity.endorStatus == 2 && (orderEndorInfoLogEntity.isInsuredStatus == 1 || orderEndorInfoLogEntity.isInsuredStatus == 7)">发票下载</el-button>
          </div>
        </el-form>
      </el-col>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">
  export default {
    name: "correctingHistoryDetails",
    data() {
      return {
        endorPolicyAddList: [],          // 加载 - 保全投保人修改后数据（）
        endorPolicySubtractList: [],     // 加载 - 保全投保人修改前数据（）
        endorInsuredAddList: [],          // 加载 - 保全增保被保人数据（）
        endorInsuredSubtractList: [],     // 加载 - 保全减保被保人数据（）
        orderId: null,                    // 加载 - 订单ID
        endorOrderId: null,               // 加载 - 保全ID
        orderEndorInfoLogEntity: {},    // 加载 - 保全实体
        insureEnsureDatum: [],            // 加载 - 保障计划
        insuredUserInfoList: [],          // 加载 - 原保单被保人数据
        insuredUserInfoNewList: [],       // 加载 - 新保单被保人数据
        endorPolicyHolderInfoList: [],    // 加载 - 新保单投保人数据
        orderEndorFileList: [],           // 加载 - 保全文件数据
        orderInfoLog: {},                 // 订单详情
        planId: null,
        productId: null,
        moneyMap: {},
        accode: '',                       // 保单号
        orderEndorToken: null,            // 保全订单token(加密)
        correctingDate: '',               // 批改生效时间
        addHeadcount: 0,                  // 加保人员数量合计
        addTotalPremium: 0,               // 加保人员保费合计
        subtractHeadcount: 0,             // 退保人员数量合计
        subtractTotalPremium: 0,          // 退保人员保费合计
        totalPremium: 0,                  // 合计保费变更
        actualPremiums: 0,                // 实际支付/实际退费（保费）
        refundWarmPrompt: false,          // 退款的温馨提示
        paidInPremium: 0,                 // 退款的温馨提示 - 佣金
        actualPremiumsName: '实际支付/实际退费',  // 实际支付/实际退费（名字）
        needInvoices: false,              // 是否需要 - 发票信息
        receiptType: 2,                   // 发票类型
        idType: '',
        chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
        // -- 被保人列表
        beInsureTableData: [],
        cityId: '', // 	城市ID
        provinceId: '', // 	省份ID
        areaId: '', // 	地区ID
        cityName: '', // 	城市名称
        provinceName: '', // 	省份名称
        areaName: '', // 地区名称
        socialCreditCode: '', // 证件号码
        address: '', // 联系人具体地址
        specificAddress: '', // 公司具体地址
        mobile: '',// 联系人手机号
        legalPerson: '', // 联系人
        workEmail: '', // 联系人邮箱
        dynamicValidateForm: {
          cards: [{
            groupSize: '',
            occId: '',
            realityOccCode: '',
            //-- 职业参数
            occOneId: '',
            occTwoList: [],
            occTwoId: '',
            occThreeList: [],
            occThreeId: '',
            occOneName: '',
            occTwoName: '',
            occThreeName: '',
            //规格值列表数据
            hurtList: [],
            medicalList: [],
            allowanceList: [],
            //规格选项值
            hurtValue: '',
            medicalValue: '',
            allowanceValue: '',
            //职业id
            occupationId: 0,
            //职业类别
            azcnCode: 0,
            //取值获取规格值下拉选项
            pid: 0,
            topLevelId: 0,
            skuInfo: {},
          }],
          companyName: '',
          guaranteePeriod: "12个月",
          insuranceAge: "18-65周岁",
          occupationType: "1-5类",
          occOneList: [],
          //-- sku参数
          skuList: [],
          skuSpecList: [],
          skuRelationAddList: [],
          occupationList: [],
        },
        orderMailInvoiceInfo: {
          tIN: '', // 纳税人识别号
          rName: '', // 收件人姓名
          rPhone: '', // 收件人手机号
          rMail: '', // 收件人邮箱
          tRA: '', // 税务登记地址
          tRT: '', // 税务登记电话
          openBank: '', // 开户银行
          bankNum: '', // 银行账户
          rCityId: '', // 	城市ID
          rProvinceId: '', // 	省份ID
          rAreaId: '', // 	地区ID
          rAddress: '', // 收件人具体地址
        },
        isEjsino: '',
        width: 1,
        fileTypeOne: false,
        fileTypeTwo: false,
        fileTypeThree: false,
        imgShow: false,
        imgUrl: '',
        aUrl:'',
        productType:'',
        bankData: []
      }
    },
    methods: {
      /**
       * e超市发票相关操作
       */
      requestInvoiceData(endorOrderToken, invoiceType){
        if( invoiceType === '03' ){
          this.axios.post('/management/mobileInsuranceInfo/requestInvoiceData?endorOrderToken=' + encodeURIComponent(decodeURIComponent(this.orderEndorInfoLogEntity.endorOrderIdNum)) +'&invoiceType=' +invoiceType).then((response) => {
            let data = response.data;
            if(data.success){
              window.open(data.datas.url, '_blank');
            }else {
              this.getOrderDetails();
              this.$message.error(data.msg);
            }
          });
        }else {
          this.$router.push({name: 'ejsinoInsureDetails', query: {invoiceType: invoiceType,  endorOrderToken: encodeURIComponent(decodeURIComponent(this.orderEndorInfoLogEntity.endorOrderIdNum)), isEndorOrder: 'true'}});
        }
      },
      uploadClick(fileUrl) {
        this.imgShow = true;
        this.imgUrl = fileUrl;
      },
      onEdit() {
        this.$router.push({name: 'ejsinoInsureDetails', query: {productId: this.productId,endorOrderToken: this.orderEndorInfoLogEntity.endorOrderIdNum}});
      },
      submitOrder() {
        let that = this;
        this.axios.post('/management/orderEndorInfoLog/orderEndorPaymentBefore?endorOrderToken=' + encodeURIComponent(decodeURIComponent(this.orderEndorInfoLogEntity.endorOrderIdNum))).then((response) => {
          let data = response.data;
          if (data.success) {
            let {payUrl} = data.datas.commission;
            let insuranceIsGroup;
            if( this.productType === 27 ) insuranceIsGroup = "4";
            if( this.productType === 20 ) insuranceIsGroup = "2";

            if( !this.$$.isValidObj(payUrl) ){
              that.$confirm('订单提交成功~', '温馨提示：', {
                distinguishCancelAndClose: true,
                showClose: false,
                closeOnClickModal: false,
                confirmButtonText: '查看保单批改列表',
                cancelButtonText: '查看批单详情'
              }).then(() => {
                that.$router.push({name: 'personnelManagement', query:{insuranceIsGroup: insuranceIsGroup}});
              }).catch(action => {
                if (action == "cancel") {
                  this.correctingInfo();
                }
              });
            }else {
              that.$confirm('订单提交成功，前往支付~', '温馨提示：', {
                showClose: false,
                closeOnClickModal: false,
                center: true,
                showCancelButton: false,
                confirmButtonText: '确认',
              }).then(() => {
                window.open(payUrl, '_blank');
                this.correctingInfo();
              });
            }
          } else {
            this.$message.error(data.msg);
            this.correctingInfo();
          }
        });
      },
      //-- 加载保全详情
      correctingInfo() {
        this.axios.post('/management/orderEndorInfoLog/orderEndorInfoLog_preservingData', {
          orderEndorToken: this.orderEndorToken,
          changeEffectiveDate: this.$$.isValidObj(this.correctingDate) ? this.$$.dateFormat(this.correctingDate) : null
        }).then((response) => {
          if (response.data.success) {
            const data = response.data.datas,
              {bankAccount, productType, cardType, cardNum, orderEndorFileList, endorPolicyHolderInfoList, isEjsino, companyName, endorInsuredUserInfoList, insureEnsureDatum, insuredUserInfoList, orderEndorInfoLogEntity, orderInfoLog, orderMailInvoiceInfo, planId, productId, moneyMap} = data;
            this.isEjsino = isEjsino;
            this.dynamicValidateForm.companyName = companyName;
            this.orderEndorInfoLogEntity = orderEndorInfoLogEntity;
            this.insureEnsureDatum = insureEnsureDatum;
            this.insuredUserInfoList = insuredUserInfoList;
            this.orderInfoLog = orderInfoLog;
            this.endorPolicyHolderInfoList = endorPolicyHolderInfoList;
            this.planId = planId;
            this.productId = productId;
            this.moneyMap = moneyMap;
            this.correctingDate = orderEndorInfoLogEntity.effectiveDate;
            this.orderEndorFileList = orderEndorFileList;
            this.productType = productType;

            if( this.$$.isValidObj(bankAccount) ){
              this.bankData = bankAccount.split("-");
            }

            this.orderEndorFileList.forEach(item => {
              if( item.fileType === 1 ){
                this.fileTypeOne = true;
              }else if (item.fileType === 2) {
                this.fileTypeTwo = true;
              }else if (item.fileType === 3) {
                this.fileTypeThree = true;
              }
            });

            if (this.addDialogVisibleState == 0) this.insuredUserInfoNewList = insuredUserInfoList;

            if (this.$$.isValidObj(orderMailInvoiceInfo)) {
              this.needInvoices = true;

              const {rName, rPhone, rMail, remark, rAddress, rProvinceId, rCityId, rAreaId, receiptType} = orderMailInvoiceInfo;

              let params = {rName, rPhone, rMail, rAddress};

              if (this.$$.isJSON(remark)) {
                const {tIN, tRT, tRA, bankNum, openBank} = JSON.parse(remark);
                if (this.$$.isValidObj(tRT) && this.$$.isValidObj(tRA) && this.$$.isValidObj(bankNum) && this.$$.isValidObj(openBank)) {
                  params = {
                    ...params, ...{
                      tRT,
                      tRA,
                      bankNum,
                      openBank,
                      rProvinceId: rProvinceId.toString(),
                      rCityId: rCityId.toString(),
                      rAreaId: rAreaId.toString()
                    }
                  };
                }
                if (this.$$.isValidObj(tIN)) params.tIN = tIN;
              }else {
                this.idType = cardType;
                this.socialCreditCode = cardNum;
              }

              if (this.$$.isValidObj(receiptType)) this.receiptType = receiptType;

              this.orderMailInvoiceInfo = {
                ...this.orderMailInvoiceInfo,
                ...params,
              };

              if (this.$$.isValidObj(rProvinceId)) {
                this.chinaArea.forEach(item => {
                  item.value === rProvinceId.toString() ? this.orderMailInvoiceInfo.rCityList = item.children : [];
                });

                this.orderMailInvoiceInfo.rCityList.forEach(item => {
                  item.value === rCityId.toString() ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
                });
              }
            }


            this.orderId = orderEndorInfoLogEntity.orderId;
            this.endorOrderId = orderEndorInfoLogEntity.id;

            this.orderInfoLog.effectiveDate = this.orderInfoLog.effectiveDate.substring(0, 10);
            this.orderInfoLog.expireDate = this.orderInfoLog.expireDate.substring(0, 10);

            this.endorInsuredAddList = [];
            this.endorInsuredSubtractList = [];

            this.endorPolicyAddList = [];
            this.endorPolicySubtractList = [];

            for (let i in endorInsuredUserInfoList) {
              const {type} = endorInsuredUserInfoList[i];
              type == 0 ? this.endorInsuredAddList.push(endorInsuredUserInfoList[i]) : this.endorInsuredSubtractList.push(endorInsuredUserInfoList[i]);
            }

            for (let i in endorPolicyHolderInfoList) {
              const {type} = endorPolicyHolderInfoList[i];
              type == 0 ? this.endorPolicyAddList.push(endorPolicyHolderInfoList[i]) : this.endorPolicySubtractList.push(endorPolicyHolderInfoList[i]);
            }

            if (orderEndorInfoLogEntity.type !== 3 && orderEndorInfoLogEntity.type !== 4) {
              this.addHeadcount = this.endorInsuredAddList.length;
              this.addTotalPremium = moneyMap.addInsureMoney;
              this.subtractHeadcount = this.endorInsuredSubtractList.length;
              this.subtractTotalPremium = moneyMap.reduceInsureMoney;
              this.totalPremium = moneyMap.changingPremium;
              this.refundWarmPrompt = Number(moneyMap.changingPremium) < 0 ? true : false;
              this.actualPremiumsName = moneyMap.changingPremium.toString().indexOf('-') >= 0 ? '实际退费' : '实际支付';
              this.actualPremiums = moneyMap.changingPremium.toString().replace('-', '');
              this.paidInPremium = moneyMap.paidInPremium;
            }
          }
        });
      },
      //-- 获取 保障计划
      supportPlan(id, type = 0) {
        for (let i in this.insureEnsureDatum) {
          const {skuId, skuProductSpecValueList} = this.insureEnsureDatum[i];
          if (skuId == id) {
            switch (type) {
              case 0: {
                return this.$$.changeNumToHan(parseInt(i) + 1);
              }
              case 1: {
                for (let j in skuProductSpecValueList) {
                  const {name, specName} = skuProductSpecValueList[j];
                  if (name == '选择职业') return specName;
                }
                break;
              }
            }
          }
        }
      },

    },
    mounted() {
      if( this.$$.isValidObj(this.$route.query.isReload) ){
        let topHref = top.location.href.substring(0,top.location.href.indexOf("/#/"));
        top.location.href = topHref + location.href.substring(location.href.indexOf("/#/"), location.href.length);
      }
      let params = sessionStorage.getItem('correctingHistoryDetailsParams');
      if( this.$$.isValidObj(this.$route.query.orderEndorToken) ){
        this.orderEndorToken = this.$route.query.orderEndorToken;
        this.accode =  this.$route.query.accode;
        this.correctingInfo();
      } else if (this.$$.isValidObj(params)) {
        params = JSON.parse(params);
        this.orderEndorToken = params.orderEndorToken;
        this.accode = params.accode;

        this.correctingInfo();
      } else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'correctingHistoryManagement', query: {type: "27"}});
        });
      }
    }
  }
</script>

<style scoped>
  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }

  .box-card-div-title > .header {
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .box-card-div-title.userInfo {
    width: 96px;
  }

  .box-card-div-title.invoiceInformation {
    width: 96px;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }

  .form-item-label,
  /deep/ .el-form-item {
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 10px;
  }

  .form-item-label .rightUnit {
    width: 280px;
    padding: 0 10px;
    display: inline-block;
    background: #F7F7F7;
  }

  /deep/ .el-form-item__content {
    padding-left: 10px;
  }

  /deep/ .warmPrompt {
    padding-left: 20px;
    font-size: 1rem;
    font-weight: 400;
    color: #FF7052;
    display: inline-block;
  }

  /deep/ .my-el-table {
    width: 900px;
  }

  .el-table /deep/ .cell {
    text-align: center;
  }

  .el-table th {
    background: #EBEBEB !important;
    border-bottom: 1px solid #CCCCCC !important;
    border-right: 1px solid #CCCCCC !important;
  }

  /deep/ .el-table--border,
  /deep/ .el-table--group {
    border: 1px solid #CCCCCC !important;
  }

  .el-table /deep/ .cell {
    display: block;
  }

  .el-table /deep/ th {
    background: #EBEBEB !important;
    border-bottom: 1px solid #CCCCCC !important;
    border-right: 1px solid #CCCCCC !important;
  }

  /deep/ .el-form-item__label {
    color: #333333;
    font-weight: bold;
    font-size: 16px !important;
  }

  /deep/ .el-form-item__content {
    padding-left: 10px;
  }

  .my-button {
    margin-right: 30px;
    background-color: #F7F7F7;
  }

  .my-button /deep/ .el-radio-button__inner {
    box-shadow: 0 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    border: 0;
    border-radius: 0 !important;
    background-color: #F7F7F7;
    color: #333333;
  }

  .is-active /deep/ .el-radio-button__inner {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    background-color: #FFEEEB !important;
    color: #FF7052 !important;
    border: 1px solid #FF7052 !important;
  }

  .my-input-left /deep/ .el-input__inner {
    max-width: 640px;
  }

  /deep/ .el-input__inner {
    max-width: 280px;
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  .submitOrder {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/preservation/correctingHistoryDetails.vue